import { useQuery } from 'react-query';
import { apiClient, endpoints } from '../api/client';

export interface ExtensionWorkerListItem {
  worker_id: string;
  provider_id?: string | null;
  display_name?: string | null;
  extension_version?: string | null;
  listener_enabled: boolean;
  status: 'idle' | 'busy' | 'offline' | 'disabled';
  current_work_item_id?: string | null;
  current_task_name?: string | null;
  current_url?: string | null;
  tasks_completed: number;
  max_concurrent_tabs?: number;
  worker_role?: 'priming' | 'scale';
  active_claim_count?: number;
  registered_at?: string | null;
  last_seen_at?: string | null;
  capabilities?: ExtensionWorkerCapability[];
}

export interface ExtensionWorkerCapability {
  marketplace_key: string;
  source: string;
  success_count?: number;
  last_success_at?: string | null;
}

export interface ExtensionWorkerSummary {
  total_registered: number;
  online: number;
  idle: number;
  busy: number;
  offline: number;
  disabled: number;
  queued_work_items: number;
}

export interface ExtensionWorkersResponse {
  workers: ExtensionWorkerListItem[];
  summary: ExtensionWorkerSummary;
  offline_threshold_seconds: number;
}

export const useExtensionWorkers = (enabled: boolean = true) => {
  return useQuery<ExtensionWorkersResponse>(
    'extensionWorkers',
    async () => {
      const response = await apiClient.get(endpoints.extensionWorkers);
      return response.data;
    },
    {
      enabled,
      refetchInterval: enabled ? 12000 : false,
      staleTime: 0,
      cacheTime: 0,
    }
  );
};
